(()=>{const root=document.querySelector('[data-sok-localization-switcher]');if(root&&root.dataset.sokCountrySupported!=='true'){const select=root.querySelector('[data-sok-country-select]');const form=select?.closest('form');if(select&&form&&[...select.options].some(o=>o.value==='DE')){const key='sok-de-fallback-v1';let attempted=false;try{attempted=sessionStorage.getItem(key)==='1'}catch(_){}if(!attempted){try{sessionStorage.setItem(key,'1')}catch(_){}select.value='DE';if(form.requestSubmit)form.requestSubmit();else form.submit();return}}}})();

(() => {
  if (window.__sokFaqLocalizationGuardLoaded) return;
  window.__sokFaqLocalizationGuardLoaded = true;

  let lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const path = location.pathname || '';
  if (path.startsWith('/de/')) lang = 'de';
  else if (path.startsWith('/nl/')) lang = 'nl';
  else if (path.startsWith('/sv/')) lang = 'sv';
  if (!['de', 'nl', 'sv'].includes(lang)) return;

  const descriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
  if (!descriptor?.get || !descriptor?.set) return;

  const normalizeFaqHtml = (html) => String(html || '')
    .replace(/\sopen(?:="")?/gi, '')
    .replace(/\sopen(?=[\s>])/gi, '');

  const protect = (root) => {
    if (!root || root.dataset.sokFaqInnerHtmlGuard === 'true') return;
    root.dataset.sokFaqInnerHtmlGuard = 'true';

    Object.defineProperty(root, 'innerHTML', {
      configurable: true,
      enumerable: descriptor.enumerable,
      get() {
        return descriptor.get.call(this);
      },
      set(value) {
        const current = descriptor.get.call(this);
        if (current === value) return;
        if (normalizeFaqHtml(current) === normalizeFaqHtml(value)) return;
        descriptor.set.call(this, value);
      },
    });
  };

  const run = () => {
    document.querySelectorAll('[data-sok-panel="faq"] .sok-faq-list').forEach(protect);
  };

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();